// variant-quantity-handler.js
(function () {
  'use strict';

  window.PXUTheme = window.PXUTheme || {};

  if (window.PXUTheme.variantQuantityHandlerInitialized) {
    return;
  }

  window.PXUTheme.variantQuantityHandlerInitialized = true;

  const BOX_SELECTOR = [
    '[data-variant-quantity-handler="product-form"]',
    '.product_form .quantity-wrapper',
    '[data-product-form] .quantity-wrapper',
    '.product_form .product-quantity-box',
    '[data-product-form] .product-quantity-box'
  ].join(',');

  function positiveInteger(value) {
    if (
      value &&
      typeof value === 'object' &&
      Object.prototype.hasOwnProperty.call(value, 'value')
    ) {
      value = value.value;
    }

    const number = parseInt(value, 10);

    if (!isNaN(number) && number > 0) {
      return number;
    }

    return null;
  }

  function getCaseSizeFromTitle(title) {
    if (!title || typeof title !== 'string') {
      return null;
    }

    const patterns = [
      /\bcs\s*[-:]?\s*(\d+)\b/i,
      /\bcase\s*[-:]?\s*(\d+)\b/i,
      /\b(\d+)\s*cs\b/i,
      /\b(\d+)\s*case\b/i
    ];

    for (let index = 0; index < patterns.length; index++) {
      const match = title.match(patterns[index]);

      if (match && match[1]) {
        const caseSize = positiveInteger(match[1]);

        if (caseSize) {
          return caseSize;
        }
      }
    }

    return null;
  }

  function getVariantMetafieldCaseSize(variant) {
    if (!variant) {
      return null;
    }

    const metafields = variant.metafields || {};

    return (
      positiveInteger(
        metafields.custom &&
        metafields.custom.case_size
      ) ||
      positiveInteger(
        metafields.wholesale &&
        metafields.wholesale.case_size
      ) ||
      positiveInteger(variant.caseSize) ||
      positiveInteger(variant.case_size)
    );
  }

  function getQuantityInput(box) {
    if (!box) {
      return null;
    }

    return box.querySelector(
      '.quantity-input, input[name="quantity"]'
    );
  }

  function getProductForm(element) {
    if (!element) {
      return null;
    }

    return element.closest(
      '[data-product-form], .product_form'
    );
  }

  function getVariantSelection(box) {
    const productForm = getProductForm(box);

    if (productForm) {
      const localSelection =
        productForm.querySelector('variant-selection');

      if (localSelection) {
        return localSelection;
      }
    }

    return document.querySelector('variant-selection');
  }

  function getOptionTitle(option) {
    if (!option) {
      return '';
    }

    let title =
      option.dataset.variantTitle ||
      option.dataset.title ||
      option.getAttribute('data-variant-title') ||
      option.getAttribute('data-title') ||
      '';

    if (title) {
      return title.trim();
    }

    if (option.tagName === 'OPTION') {
      return option.textContent.trim();
    }

    const parentLabel = option.closest('label');

    if (parentLabel) {
      return parentLabel.textContent.trim();
    }

    if (option.id) {
      const label = document.querySelector(
        'label[for="' + option.id + '"]'
      );

      if (label) {
        return label.textContent.trim();
      }
    }

    return '';
  }

  function getCurrentVariant(selection) {
    if (!selection) {
      return null;
    }

    if (
      selection.variant &&
      typeof selection.variant === 'object'
    ) {
      return selection.variant;
    }

    let variantId = null;

    if (
      selection.variant &&
      selection.variant !== 'not-selected'
    ) {
      variantId = selection.variant;
    }

    let selectedOption = null;

    const options = selection.querySelectorAll(
      'input, option'
    );

    for (let index = 0; index < options.length; index++) {
      const option = options[index];

      if (
        variantId &&
        String(option.value) === String(variantId)
      ) {
        selectedOption = option;
        break;
      }

      if (option.checked || option.selected) {
        selectedOption = option;
      }
    }

    const variant = {
      id: variantId,
      title: getOptionTitle(selectedOption),
      metafields: selection.variantMetafields || {}
    };

    if (
      !variant.title &&
      selection.dataset &&
      selection.dataset.variantTitle
    ) {
      variant.title = selection.dataset.variantTitle;
    }

    if (
      selectedOption &&
      selectedOption.dataset &&
      selectedOption.dataset.caseSize
    ) {
      variant.metafields = variant.metafields || {};
      variant.metafields.custom =
        variant.metafields.custom || {};

      variant.metafields.custom.case_size =
        selectedOption.dataset.caseSize;
    }

    return variant;
  }

  function getStepFromVariant(variant, box) {
    const input = getQuantityInput(box);
      // Tester is a single unit, never a case — force it before
      // falling through to the stale dataset fallbacks below.
      const explicitTitle = (variant && variant.title) ? variant.title : '';
      if (/\btester\b/i.test(explicitTitle)) {
        return 1;
      }
    /*
     * Selected variant title must come first.
     *
     * This allows:
     * Tin | CS 12
     * Refill | CS 6
     * Refill | CS 3
     *
     * The product metafield is only used when the selected
     * variant title does not contain its own case size.
     */
    const step =
      getCaseSizeFromTitle(
        variant && variant.title
          ? variant.title
          : ''
      ) ||
      getCaseSizeFromTitle(
        box && box.dataset
          ? box.dataset.variantTitle
          : ''
      ) ||
      getVariantMetafieldCaseSize(variant) ||
      getCaseSizeFromTitle(
        box && box.dataset
          ? box.dataset.productTitle
          : ''
      ) ||
      positiveInteger(
        box && box.dataset
          ? box.dataset.caseSize
          : null
      ) ||
      positiveInteger(
        input && input.dataset
          ? input.dataset.caseSize
          : null
      ) ||
      1;

    console.log('Quantity case size selected:', {
      step: step,
      variantTitle:
        variant && variant.title
          ? variant.title
          : '',
      storedVariantTitle:
        box && box.dataset
          ? box.dataset.variantTitle
          : '',
      productTitle:
        box && box.dataset
          ? box.dataset.productTitle
          : ''
    });

    return step;
  }

  function updateMinusButton(box, value, step) {
    const minusButton = box.querySelector(
      '.quantity-minus, .minus-control, [data-update-quantity="minus"]'
    );

    if (!minusButton) {
      return;
    }

    if (value <= step) {
      minusButton.setAttribute(
        'disabled',
        'disabled'
      );

      minusButton.setAttribute(
        'aria-disabled',
        'true'
      );
    } else {
      minusButton.removeAttribute('disabled');
      minusButton.removeAttribute('aria-disabled');
    }
  }

  function updateQuantitySelectorForBox(box, variant) {
    if (!box) {
      return;
    }

    const input = getQuantityInput(box);

    if (!input) {
      return;
    }

    const oldStep =
      positiveInteger(input.dataset.step) ||
      positiveInteger(box.dataset.step) ||
      1;

    const newStep = getStepFromVariant(
      variant || {},
      box
    );

    input.setAttribute('min', String(newStep));
    input.setAttribute('step', String(newStep));
    input.setAttribute('data-min', String(newStep));
    input.setAttribute('data-step', String(newStep));
    input.setAttribute(
      'data-case-size',
      String(newStep)
    );

    input.dataset.min = String(newStep);
    input.dataset.step = String(newStep);
    input.dataset.caseSize = String(newStep);

    box.setAttribute('data-step', String(newStep));
    box.setAttribute(
      'data-case-size',
      String(newStep)
    );

    box.dataset.step = String(newStep);
    box.dataset.caseSize = String(newStep);

    if (variant && variant.id) {
      box.setAttribute(
        'data-variant-id',
        String(variant.id)
      );
    }

    if (variant && variant.title) {
      box.setAttribute(
        'data-variant-title',
        variant.title
      );

      box.dataset.variantTitle = variant.title;
    }

    const currentValue =
      positiveInteger(input.value);

    let newValue = currentValue;

    if (!currentValue) {
      newValue = newStep;
    } else if (oldStep !== newStep) {
      /*
       * When switching from CS 6 to CS 12 or CS 3,
       * reset to one full case.
       */
      newValue = newStep;
    } else if (currentValue < newStep) {
      newValue = newStep;
    } else if (currentValue % newStep !== 0) {
      newValue =
        Math.ceil(currentValue / newStep) * newStep;
    }

    input.value = String(newValue);
    input.defaultValue = String(newValue);
    input.setAttribute(
      'value',
      String(newValue)
    );

    box
      .querySelectorAll(
        '[data-update-quantity], .minus-control, .plus-control, .quantity-minus, .quantity-plus'
      )
      .forEach(function (control) {
        control.setAttribute(
          'data-step',
          String(newStep)
        );

        control.dataset.step = String(newStep);
      });

    updateMinusButton(
      box,
      newValue,
      newStep
    );

    input.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function findQuantityBox(selection) {
    const productForm = getProductForm(selection);

    if (productForm) {
      const localBox = productForm.querySelector(
        '.quantity-wrapper, .product-quantity-box'
      );

      if (localBox) {
        return localBox;
      }
    }

    return document.querySelector(BOX_SELECTOR);
  }

  function scheduleQuantityUpdate(
    box,
    suppliedVariant
  ) {
    if (!box) {
      return;
    }

    const delays = [0, 50, 150, 400, 800];

    delays.forEach(function (delay) {
      window.setTimeout(function () {
        let currentVariant = suppliedVariant;

        if (!currentVariant) {
          currentVariant = getCurrentVariant(
            getVariantSelection(box)
          );
        }

        updateQuantitySelectorForBox(
          box,
          currentVariant || {}
        );
      }, delay);
    });
  }

  function bindVariantSelection(selection) {
    if (
      !selection ||
      selection.dataset.quantityHandlerBound ===
        'true'
    ) {
      return;
    }

    selection.dataset.quantityHandlerBound = 'true';

    selection.addEventListener(
      'variant-change',
      function (event) {
        const box = findQuantityBox(selection);

        const variant =
          event.detail && event.detail.variant
            ? event.detail.variant
            : getCurrentVariant(selection);

        scheduleQuantityUpdate(
          box,
          variant
        );
      }
    );

    selection.addEventListener(
      'change',
      function () {
        const box = findQuantityBox(selection);

        /*
         * Re-read the selected variant after the theme
         * finishes changing its selection.
         */
        scheduleQuantityUpdate(
          box,
          null
        );
      }
    );
  }

  function initializeQuantityHandlers() {
    document
      .querySelectorAll('variant-selection')
      .forEach(function (selection) {
        bindVariantSelection(selection);
      });

    document
      .querySelectorAll(BOX_SELECTOR)
      .forEach(function (box) {
        box.setAttribute(
          'data-variant-quantity-handler',
          'product-form'
        );

        scheduleQuantityUpdate(
          box,
          getCurrentVariant(
            getVariantSelection(box)
          )
        );
      });
  }

  function initialize() {
    initializeQuantityHandlers();

    window.setTimeout(
      initializeQuantityHandlers,
      250
    );

    window.setTimeout(
      initializeQuantityHandlers,
      750
    );

    window.setTimeout(
      initializeQuantityHandlers,
      1500
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  window.addEventListener(
    'load',
    initializeQuantityHandlers
  );

  document.addEventListener(
    'shopify:section:load',
    initializeQuantityHandlers
  );

  window.PXUTheme.variantQuantityHandler = {
    getStep: function (variant) {
      const box =
        document.querySelector(BOX_SELECTOR);

      return getStepFromVariant(
        variant || {},
        box
      );
    },

    updateQuantitySelector: function (variant) {
      document
        .querySelectorAll(BOX_SELECTOR)
        .forEach(function (box) {
          scheduleQuantityUpdate(
            box,
            variant || null
          );
        });
    }
  };
})();